export enum TicketStatus {
  Won,
  Lost,
  Pending,
  Returned,
  Canceled,
}
